import api from '../api/news'
import { setListData } from './meta'

export const actionTypes = {
	RECEIVE_NEWS: 'news/RECEIVE_NEWS',
  RECEIVE_SECTOR_NEWS: 'news/RECEIVE_SECTOR_NEWS',
  RECEIVE_ORDERED_NEWS: 'news/RECEIVE_ORDERED_NEWS',
  SAVE_ORDER: 'news/SAVE_ORDER'
}

export const loadNews = () => {
	return (dispatch, getStore) => {
    api.fetchNewsList()
      .then((data) => {
      	dispatch(receiveNewsList(data))
      	dispatch(setListData(data))
      })
  }
}

export const loadNewsBySector = (id) => {
  return(dispatch, getStore) => {
    api.fetchNewsBySector(id)
      .then((data) => dispatch(receiveSectorNews(data)))
  }
}

export const setOrder = (value) => {
  return(dispatch, getStore) => {
    api.fetchNewsOrdered(value)
      .then((data) => dispatch(receiveOrderedNews(data)))
  }
}

function receiveNewsList(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEWS,
    data: APIdata.data
  }
}

export const saveOrder = (value) => {
  return {
    type: actionTypes.SAVE_ORDER,
    data: value
  }
}

function receiveSectorNews(APIdata) {
  return {
    type: actionTypes.RECEIVE_SECTOR_NEWS,
    data: APIdata
  }
}

function receiveOrderedNews(APIdata) {
  return {
    type: actionTypes.RECEIVE_ORDERED_NEWS,
    data: APIdata.data
  }
}



// WEBPACK FOOTER //
// ./src/actions/news.js